if (!customElements.get('custom-product-form')) {
  customElements.define('custom-product-form', class CustomProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.action = this.dataset.action || 'add_to_cart';

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.action === 'add_to_cart' && this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'custom-product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'custom-product-form', productVariantId: formData.get('id')});
          this.error = false;

          if (this.action === 'add_and_checkout') {
            // Check if we need to add a product-based gift before going to checkout
            const giftConfig = window.__productGiftConfig;
            if (giftConfig && giftConfig.enabled && giftConfig.giftVariantId && giftConfig.triggerProductIds.length) {
              // Fetch cart to check if a trigger product is present
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  const hasTrigger = cart.items.some(item =>
                    giftConfig.triggerProductIds.includes(item.product_id) && item.variant_id !== giftConfig.giftVariantId
                  );
                  const hasGift = cart.items.some(item => item.variant_id === giftConfig.giftVariantId);

                  if (hasTrigger && !hasGift) {
                    // Add the gift, then go to checkout
                    fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ id: giftConfig.giftVariantId, quantity: 1 })
                    }).then(() => {
                      window.location.href = '/checkout';
                    }).catch(() => {
                      window.location.href = '/checkout';
                    });
                  } else {
                    window.location.href = '/checkout';
                  }
                })
                .catch(() => {
                  window.location.href = '/checkout';
                });
            } else {
              window.location.href = '/checkout';
            }
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
